import { createContext } from 'react';

export type ItemsContextType = {
  fetchItemsInfo?: () => Promise<any>;
  fetchUpcomingOrdersInfo?: () => Promise<any>;
  updateQuantityFn?: ({ quantity }) => Promise<any>;
  frequencyOptions?: object[];
  storeId?: string;
  skipItemOnce?: (itemInfo: any) => Promise<any>;
  rescheduleItem?: (itemInfo: any) => Promise<any>;
  otaToSnsFrequencyOptions?: object[];
};
export const ItemsContext = createContext<ItemsContextType | null>(null);
